module.exports = __webpack_public_path__ + "img/icon-info.742a76c4.svg";